/* heyshappy.pl: kwoty w formacie sklepu .pl (1.699,00 zl; rabat bez groszy: 79 zl). Port z .com 19.10.2026 (zbuduj_pl.py). */
/* heyshappy.com, strony zestawow (sekcja shappy-bundle-sofa-arches). Generowane przez outputs/zestaw-sofa-luki-20261015/wydziel_js.py, nie edytowac recznie. */
(function(){
  var C = []; try { C = JSON.parse(document.querySelector('[data-shb-cfg]').textContent); } catch (e) { return; }
  var root = document.getElementById('shb-' + C[4]);
  if (!root || root.dataset.shbInit) return;
  root.dataset.shbInit = '1';
  var pairs = [];
  try { pairs = JSON.parse(root.querySelector('[data-shb-pairs]').textContent); } catch (e) {}
  var FIX = { c: C[8], note: C[11] };
  var GIFT = { extra: C[9], val: C[10], txt: C[12] };
  var S = { show_compare_at: C[13], show_save: C[14], open_drawer: C[15] };
  var T = { cta: C[16], cta_aria_offer: C[17], list_extra: C[18], offer_line: C[19], trust: C[20], sticky_title: C[21], t_adding: C[22], t_error: C[23], t_unavailable: C[24],
    disc: C[25], savef: C[26], approx: C[27], cur: C[28], approx_note: C[29], start: C[30], end: C[31],
    save_label: C[32], price_note: C[33], price_note_offer: C[34],
    timer_title: C[35], timer_title_last: C[36], timer_end: C[37], bar_text: C[38], bar_text_last: C[39], bar_timer: C[40],
    teaser_midnight: C[41], teaser_today: C[42], teaser_tomorrow: C[43], teaser_date: C[44],
    x_name: C[45], hook: C[46], hook_plain: C[47], ben_1: C[48], anim_caption: C[49], anim_caption_plain: C[50],
    gal_alt: C[51], sofa_name: C[52], build_alt: C[53], arch_alt: C[54], heading: C[55], lang: C[56] };
  var cartUrl = C[57];
  var addUrl = C[58];
  var swatchBase = C[59];
  // kwoty w tym samym formacie co strony produktow (Intl wg jezyka strony i waluty rynku)
  var LANG = document.documentElement.lang || 'en';
  var OSZ = ((document.querySelector('[data-shb-osz]') || {}).getAttribute ? document.querySelector('[data-shb-osz]').getAttribute('data-shb-osz') : '') || 'pelna';
  function PLN(c, z){ var pz = (Math.round(c) / 100).toFixed(2).split('.'); var w = pz[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return (z && pz[1] === '00' ? w : w + ',' + pz[1]) + ' z\u0142'; }
  function F0(c){ if (T.cur === 'PLN') return PLN(c, true); try { return new Intl.NumberFormat(LANG, { style: 'currency', currency: T.cur || 'EUR', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100); } catch (e) { return F(c); } }
  function F(c){ if (T.cur === 'PLN') return PLN(c, false); try { return new Intl.NumberFormat(LANG, { style: 'currency', currency: T.cur || 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + (T.cur || 'EUR'); } }
  if (T.disc && T.approx){ var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1; T.disc = Math.round(T.disc * rate); }
  if (T.disc){ T.savef = (T.approx ? C[60] + ' ' : '') + F0(T.disc); }
  function norm(p){
    if (p.fx && !p.fxd){ p.tot -= p.fx; p.fxd = 1; }
    if (OSZ === 'zestaw'){ p.cmpc = p.fx ? p.tot + p.fx : 0; }
    p.totf = F(p.tot); p.cmpf = p.cmpc > 0 ? F(p.cmpc) : ''; if (T.disc) p.dtotf = F(p.tot - T.disc);
    p.s.pf = F(p.s.p); p.s.cf = p.s.c > 0 ? F(p.s.c) : '';
    p.a.pf = F(p.a.p); p.a.cf = p.a.c > 0 ? F(p.a.c) : ''; if (T.disc) p.a.dpf = F(p.a.p - T.disc);
    if (p.x){ p.x.pf = F(p.x.p); p.x.cf = p.x.c > 0 ? F(p.x.c) : ''; }
    p.a.newf = T.disc ? ((T.approx ? T.approx_prefix + ' ' : '') + F(p.a.p - T.disc)) : p.a.pf;
  }
  pairs.forEach(norm);
  // pozostale tkaniny: dane z /products/<uchwyt>.js dopiero po wyborze tkaniny (lzejszy HTML)
  var FAB_OK = {}; pairs.forEach(function(p){ FAB_OK[p.f] = 1; });
  var ROOT = C[61] === '/' ? '' : C[62];
  function slugOf(c){ return String(c).toLowerCase().replace(/\s+/g, '-'); }
  function mapOf(str){ var m = {}; String(str || '').split(',').forEach(function(kv){ var a = kv.split(':'); if (a.length === 2) m[a[0].trim()] = a[1].trim(); }); return m; }
  function cIdx(pr){ var n = (pr.options || []).map(function(o){ return String(o.name || o).toLowerCase().trim(); }); for (var i = 0; i < n.length; i++){ if (/^(color|colour|farbe|kleur|couleur|kolor|colore)$/.test(n[i])) return i; } return n.length - 1; }
  function img(pr, v, w){ var u = (v && v.featured_image && v.featured_image.src) || pr.featured_image || ''; if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function getP(h){ return fetch(ROOT + '/products/' + h + '.js', { credentials: 'same-origin' }).then(function(r){ if (!r.ok) throw r; return r.json(); }); }
  function loadFab(k){
    if (FAB_OK[k]) return Promise.resolve();
    var f = FABS.filter(function(x){ return x.k === k; })[0]; if (!f) return Promise.reject();
    return Promise.all([getP(f.s), getP(f.a), f.x ? getP(f.x) : Promise.resolve(null)]).then(function(r){
      var ps = r[0], pa = r[1], px = r[2], is = cIdx(ps), ia = cIdx(pa), ix = px ? cIdx(px) : -1, pm = mapOf(f.pm), fpm = mapOf(f.fpm), seen = {};
      var roleA = C[63], roleX = C[64];
      function find(pr, i, want){ for (var j = 0; j < pr.variants.length; j++){ if (String(pr.variants[j].options[i]).toLowerCase() === want) return pr.variants[j]; } return null; }
      function part(pr, v){ var c = v.compare_at_price > v.price ? v.compare_at_price : 0; return { c: c, id: v.id, sku: v.sku, p: v.price, t: v.title, u: pr.url + '?variant=' + v.id }; }
      ps.variants.forEach(function(sv){
        var col = sv.options[is], cl = String(col).toLowerCase(); if (seen[cl]) return; seen[cl] = 1;
        var want = pm[cl] || cl, fut = fpm[cl] || want;
        var av = find(pa, ia, roleA === 'futon' ? fut : want); if (!av) return;
        var xv = null; if (px){ xv = find(px, ix, roleX === 'futon' ? fut : want); if (!xv) return; }
        var tot = sv.price + av.price + (xv ? xv.price : 0);
        var all = Math.max(sv.compare_at_price || 0, sv.price) + Math.max(av.compare_at_price || 0, av.price) + (xv ? Math.max(xv.compare_at_price || 0, xv.price) : 0);
        var p = { f: k, sw: slugOf(cl), fx: f.fx, c: col, ac: av.options[ia], slug: k + '--' + slugOf(cl), ok: !!(sv.available && av.available && (!xv || xv.available)), tot: tot, cmpc: all > tot ? all : 0, p1fb: '',
          s: part(ps, sv), a: part(pa, av), si: img(ps, sv, 200), ai: img(pa, av, 200), si6: img(ps, sv, 600), ai6: img(pa, av, 600),
          q1: img(pa, av, 1200), q6: img(pa, av, 600), r1: img(ps, sv, 1200), r6: img(ps, sv, 600), an: img(ps, sv, 1200),
          s1: img(ps, sv, 1200), s6: img(ps, sv, 600), a1: img(pa, av, 1200), a6: img(pa, av, 600),
          sn: String(ps.title).replace(/^Shappy /, '').replace(/Pure Corduroy (?=(Waffle|Teddy)\b)/, ''), anm: String(pa.title).replace(/^Shappy /, '').replace(/Pure Corduroy (?=(Waffle|Teddy)\b)/, '') };
        if (xv){ p.x = part(px, xv); p.x.col = xv.options[ix]; p.xi = img(px, xv, 200); p.xi6 = img(px, xv, 600); p.x1 = img(px, xv, 1200); p.x6 = img(px, xv, 600); p.xnm = String(px.title).replace(/^Shappy /, '').replace(/Pure Corduroy (?=(Waffle|Teddy)\b)/, ''); }
        norm(p); pairs.push(p);
      });
      FAB_OK[k] = 1;
    });
  }
  function archVals(){ var p = (typeof cur !== 'undefined' && cur) || pairs[0] || { a: {} }; return [p.a.newf || '', p.a.pf || '']; }
  function amtA(s){ var v = archVals(); return String(s || '').replace('%amount%', T.savef || '').split('%arch_new%').join(v[0]).split('%arch_old%').join(v[1]); }
  root.querySelectorAll('[data-shb-amt]').forEach(function(el){ el.textContent = amtA(el.getAttribute('data-shb-amt')); });
  var q = function(s){ return root.querySelector(s); };
  var cta = q('[data-shb-add]'), ctaS = q('[data-shb-add-sticky]'), msg = q('[data-shb-msg]');
  if (!pairs.length){ msg.textContent = T.t_unavailable; return; }
  var swBox = q('[data-shb-swatches]');
  var FABS = C[6];
  var params = new URLSearchParams(location.search);
  var curFab = (params.get('stoff') || params.get('tkanina') || params.get('fabric') || '').toLowerCase();
  if (!FABS.some(function(f){ return f.k === curFab; })) curFab = FABS.length ? FABS[0].k : '';
  var wantFab = curFab; if (FABS.length && !pairs.some(function(p){ return p.f === curFab; })) curFab = FABS[0].k;
  function inFab(p){ return !p.f || p.f === curFab; }
  var wantParam = (params.get('kolor') || params.get('color') || params.get('colour') || params.get('farbe') || '').toLowerCase();
  var wanted = wantParam || String(C[65]).toLowerCase();
  var cur = null;
  function byColour(c){ for (var i = 0; i < pairs.length; i++){ if (inFab(pairs[i]) && pairs[i].c.toLowerCase() === c) return pairs[i]; } return null; }
  function firstOk(){ for (var i = 0; i < pairs.length; i++){ if (inFab(pairs[i]) && pairs[i].ok) return pairs[i]; } for (var j = 0; j < pairs.length; j++){ if (inFab(pairs[j])) return pairs[j]; } return pairs[0]; }
  cur = byColour(wanted);
  if (!cur || !cur.ok) cur = firstOk();
  var offerState = 'off', urgent = false;
  var reduce = false; try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function amt(s){ return amtA(s); }
  function promo(){ return offerState === 'active' && !!T.savef; }
  function ctaLabel(){ return promo() ? amt(T.cta_aria_offer) : T.cta; }
  // daty startu i konca w jezyku strony, zawsze czas warszawski (jedno zrodlo: ustawienia offer_start_utc / offer_end_utc)
  function wFmt(ms, o){ try { return new Intl.DateTimeFormat(({ en: 'en-GB', de: 'de-DE', fr: 'fr-FR', nl: 'nl-NL', es: 'es-ES', pl: 'pl-PL' })[String(T.lang || 'en').slice(0, 2)] || 'en-GB', Object.assign({ timeZone: 'Europe/Warsaw' }, o)).format(new Date(ms)); } catch (e) { return new Date(ms).toISOString().slice(0, 16).replace('T', ' '); } }
  function wTime(ms){ return wFmt(ms, { hour: '2-digit', minute: '2-digit', hour12: false }); }
  function wShort(ms){ return wFmt(ms, { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }); }
  function wDate(ms){ return wFmt(ms, { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', hour12: false }); }

  // ---- gallery (scroll-snap, set photos only) ----
  var track = q('[data-shb-track]'), thumbs = q('[data-shb-thumbs]'), count = q('[data-shb-count]'), gIdx = 0, gN = 0;
  function wake(i){ [i - 1, i, i + 1].forEach(function(j){ var sl = track.children[j]; var im = sl && sl.querySelector('img[data-src]'); if (im){ if (im.dataset.srcset) im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); } }); }
  function mark(i){
    wake(i);
    gIdx = i;
    count.textContent = (i + 1) + ' / ' + gN;
    Array.prototype.forEach.call(thumbs.children, function(b, k){ b.classList.toggle('is-active', k === i); });
  }
  function goTo(i){
    if (!gN) return;
    i = (i + gN) % gN;
    track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    mark(i);
  }
  // galeria taka sama w kazdym kolorze (Joanna 15.10): luki nad sofa i budowla w Vanilla, zdjecia produktowe, zdjecia z zycia
  var SLOTS = (C[0] ? (C[1] ? ['k', 'p', 'a'] : ['s', 'a']) : ['q', 'r']).concat(C[2] ? ['x'] : []);
  var OFF = C[3];
  var LIFE = C[7].filter(Boolean), SLOTG = SLOTS.map(function(k, i){ return { u: '', s: '', k: i === 1 && k === 'r' ? 'set' : 'arch', key: k, w: 1200, h: 1200 }; });
  var GAL = OFF ? LIFE.slice(0, OFF).concat(SLOTG, LIFE.slice(OFF)) : SLOTG.concat(LIFE);
  function altFor(key){ if (key === 'x') return (T.x_name || T.heading) + ', ' + ((cur.x && cur.x.col) || cur.c); if (key === 's') return T.sofa_name + ', ' + cur.c; if (key === 'k' || key === 'p') return T.heading + ', ' + cur.c; if (key === 'r') return T.gal_alt.replace('%colour%', cur.c); return T.arch_alt.replace('%colour%', cur.ac || cur.c); }
  var SIZES = '(max-width: 989px) 80vw, 640px', pre = {};
  function pl(u6, u1){ var im = new Image(); im.sizes = SIZES; im.srcset = u6 + ' 600w, ' + u1 + ' 1200w'; im.src = u1; return im; }
  function preload(p){ if (!p) return null; if (!pre[p.slug]) pre[p.slug] = SLOTS.map(function(k){ return pl(p[k + '6'], p[k + '1']); }); return pre[p.slug]; }
  // zmiana koloru: podmiana tylko slajdu 1; stary obraz widoczny, dopoki nowy sie nie zaladuje; galeria wraca na slajd 1
  function swapFirst(){ SLOTS.forEach(function(k, i){ swapSlide(i + OFF, k); }); if (gIdx !== OFF) goTo(OFF); }
  function swapSlide(n, key){
    var sl = track.children[n], im = sl && sl.querySelector('img'); if (!im) return;
    var p = cur, ld = preload(p)[n - OFF], u1 = p[key + '1'], u6 = p[key + '6'];
    function put(){ if (cur !== p) return; im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); im.sizes = SIZES; im.srcset = u6 + ' 600w, ' + u1 + ' 1200w'; im.src = u1; im.alt = altFor(key); var t0 = thumbs.children[n] && thumbs.children[n].querySelector('img'); if (t0){ if (t0.dataset.src) t0.dataset.src = u6; else t0.src = u6; } }
    if (ld.complete && ld.naturalWidth) put(); else { ld.addEventListener('load', put, { once: true }); ld.addEventListener('error', put, { once: true }); }
  }
  function swapFirstOld(){
    var sl = track.children[0], im = sl && sl.querySelector('img'); if (!im) return;
    var p = cur, ld = preload(p)[0];
    function put(){ if (cur !== p) return; im.sizes = SIZES; im.srcset = p.q6 + ' 600w, ' + p.q1 + ' 1200w'; im.src = p.q1; im.alt = T.arch_alt.replace('%colour%', cur.ac || cur.c); var t0 = thumbs.children[0] && thumbs.children[0].querySelector('img'); if (t0){ if (t0.dataset.src) t0.dataset.src = p.q6; else t0.src = p.q6; } }
    if (ld.complete && ld.naturalWidth) put(); else { ld.addEventListener('load', put, { once: true }); ld.addEventListener('error', put, { once: true }); }
    if (gIdx !== 0) goTo(0);
  }
  var ANIM = C[66], BUILT = C[67], galBuilt = false;
  function wsrc(u, w){ return u.indexOf('width=') > -1 ? u.replace(/width=\d+/, 'width=' + w) : u; }
  function buildGal(){
    if (galBuilt){ swapFirst(); return; } galBuilt = true;
    SLOTS.forEach(function(k, i){ GAL[i + OFF].u = cur[k + '1'] || ''; GAL[i + OFF].s = cur[k + '6'] || ''; });
    track.innerHTML = ''; thumbs.innerHTML = '';
    var list = GAL; gN = list.length;
    list.forEach(function(g, k){
      var u = g.u, kind = g.k, isPhoto = kind === 'photo', isCover = kind === 'fab', isCdn = u.indexOf('width=') > -1;
      var slide = document.createElement('div'); slide.className = 'shb__slide shb__slide--' + kind + ((isPhoto || isCover) ? ' shb__slide--photo shb__slide--cover' : '');
      var im = document.createElement('img'); if (k === 0 && cur.p1fb){ im.onerror = function(){ im.onerror = null; im.src = cur.p1fb; var t0 = thumbs.children[0] && thumbs.children[0].querySelector('img'); if (t0) t0.src = cur.p1fb; }; }
      var ss = isCdn ? (wsrc(u, 600) + ' 600w, ' + u + ' 1200w') : (g.s ? (g.s + ' 600w, ' + u + ' 1200w') : '');
      if (ss) im.sizes = '(max-width: 989px) 80vw, 640px';
      if (k === 0){ im.fetchPriority = 'high'; im.setAttribute('fetchpriority', 'high'); }
      if (k < 2){ if (ss) im.srcset = ss; im.src = u; } else { im.dataset.src = u; if (ss) im.dataset.srcset = ss; }
      im.alt = g.key ? altFor(g.key) : kind === 'arch' ? T.arch_alt.replace('%colour%', cur.ac || cur.c) : kind === 'sofa' || kind === 'fab' ? T.sofa_name + ', Vanilla' : kind === 'photo' ? T.heading : T.gal_alt.replace('%colour%', cur.c);
      im.width = g.w || 1200; im.height = g.h || 1200; if (g.p) im.style.objectPosition = g.p; if (k > 0){ im.loading = 'lazy'; im.decoding = 'async'; }
      slide.appendChild(im); track.appendChild(slide);
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (k + 1) + ' / ' + gN); b.className = (isPhoto || isCover) ? 'is-photo-b' : 'is-white';
      var ti = document.createElement('img'); if (isPhoto || isCover) ti.className = 'is-photo'; ti.dataset.src = isCdn ? wsrc(u, 200) : (g.s || u); if (g.p) ti.style.objectPosition = g.p; ti.alt = ''; ti.loading = 'lazy'; ti.width = 64; ti.height = 64;
      b.appendChild(ti); b.addEventListener('click', function(){ goTo(k); }); thumbs.appendChild(b);
    });
    track.scrollLeft = 0; mark(0);
    if (thumbs.offsetParent){
      var tio = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting && e.target.dataset.src){ e.target.src = e.target.dataset.src; e.target.removeAttribute('data-src'); tio.unobserve(e.target); } }); }, { root: thumbs, rootMargin: '0px 140px' }) : null;
      thumbs.querySelectorAll('img[data-src]').forEach(function(t){ if (tio) tio.observe(t); else { t.src = t.dataset.src; t.removeAttribute('data-src'); } });
    }
    var multi = gN > 1;
    q('[data-shb-prev]').hidden = !multi; q('[data-shb-next]').hidden = !multi; count.hidden = !multi;
  }
  var raf = 0;
  track.addEventListener('scroll', function(){
    if (raf) return;
    raf = requestAnimationFrame(function(){ raf = 0; var w = track.clientWidth || 1; var i = Math.round(track.scrollLeft / w); if (i !== gIdx && i >= 0 && i < gN) mark(i); });
  }, { passive: true });
  q('[data-shb-prev]').addEventListener('click', function(){ goTo(gIdx - 1); });
  q('[data-shb-next]').addEventListener('click', function(){ goTo(gIdx + 1); });

  function setLink(sel, url, id){ root.querySelectorAll(sel).forEach(function(a){ a.href = url.split('?')[0] + '?variant=' + id; }); }

  // ---- texts that depend on the offer ----
  function ctaBadge(){ return ''; }
  function offerLine(){ return (promo() && cur && cur.dtotf) ? amt(T.offer_line).replace('%old%', cur.totf).replace('%new%', cur.dtotf) : ''; }
  function archNew(){ return archVals()[0]; }
  function archOld(){ return archVals()[1]; }
  function renderCtaBtns(plain){
    var price = (promo() && cur.dtotf) ? cur.dtotf : cur.totf;
    [cta, ctaS].forEach(function(b){
      if (!b) return;
      var lb = b.querySelector('[data-shb-cta-label]'); if (lb) lb.textContent = T.cta;
      var pr = b.querySelector('[data-shb-cta-price]'); if (pr){ pr.textContent = price ? '\u00a0\u00b7 ' + price : ''; pr.hidden = false; }
      b.setAttribute('aria-label', plain + (price ? ' \u00b7 ' + price : ''));
    });
    fitCta();
  }
  // przycisk w jednej linii: gdy napis z cena sie nie miesci (np. FR na 375 px), cena znika z przycisku (jest nad nim)
  function fitCta(){
    [cta, ctaS].concat(Array.prototype.slice.call(document.querySelectorAll('[data-shb-final-cta]'))).forEach(function(b){
      if (!b) return; var pr = b.querySelector('[data-shb-cta-price],[data-shf-price]'); if (!pr || !pr.textContent) return;
      pr.hidden = false; var lb = b.querySelector('[data-shb-cta-label],[data-shf-label]');
      if (lb && pr.offsetTop > lb.offsetTop + 4) pr.hidden = true;
    });
  }
  window.addEventListener('resize', function(){ fitCta(); });

  function renderOfferTexts(){
    var on = promo();
    var hk = q('[data-shb-hook]'); if (hk && !hk.hidden) hk.textContent = on ? amt(T.hook) : amt(T.hook_plain);
    var ben = q('[data-shb-ben-save]'); ben.textContent = amt(T.ben_1); ben.hidden = !on;
    q('[data-shb-anim-cap]').textContent = on ? amt(T.anim_caption) : T.anim_caption_plain;
    var l = ctaLabel(); renderCtaBtns(l);
    document.querySelectorAll('[data-shb-final-cta]').forEach(function(b){ b.textContent = l; });
    document.dispatchEvent(new CustomEvent('shb:update', { detail: { savef: T.savef, state: offerState, promo: on, label: l, main: T.cta, badge: '', trust: T.trust, price: (on && cur.dtotf) ? cur.dtotf : cur.totf, archNew: archNew(), archOld: archOld(), start: (typeof START === 'number') ? startTxt() : '', end: (typeof END === 'number') ? endTxt() : '' } }));
  }
  function renderPrice(){
    var act = offerState === 'active' && cur.dtotf;
    q('[data-shb-total]').textContent = act ? cur.dtotf : cur.totf;
    q('.shb__price').classList.toggle('is-offer', !!act);
    var cmp = q('[data-shb-cmp]'), save = q('[data-shb-save]'), note = q('[data-shb-price-note]');
    if (act){
      cmp.textContent = cur.totf; cmp.hidden = false;
      save.hidden = true; // bez "Du sparst": korzysc pokazuje linia o cenie lukow
      var fr0 = q('[data-shb-fix-row]'); if (fr0) fr0.hidden = true;
      note.textContent = (T.approx && T.approx_note) ? T.approx_note.replace('%cur%', T.cur) : amt(T.price_note_offer);
    } else {
      var showCmp = (S.show_compare_at || S.show_save) && cur.cmpf;
      if (showCmp){ cmp.textContent = cur.cmpf; cmp.hidden = false; } else { cmp.hidden = true; }
      var sv = S.show_save ? Math.max(0, cur.cmpc > cur.tot ? cur.cmpc - cur.tot : 0) + GIFT.extra : 0;
      var inc = q('[data-shb-incl]'); if (inc){ inc.textContent = GIFT.extra ? GIFT.txt.replace('%price%', F0(GIFT.val)) : ''; inc.hidden = !GIFT.extra; }
      save.textContent = sv ? T.save_label.replace('%amount%', F0(sv)) : ''; save.hidden = !sv; note.textContent = (cur.fx && FIX.note) ? FIX.note : T.price_note;
      var fr = q('[data-shb-fix-row]'); if (fr){ fr.hidden = !cur.fx; if (cur.fx) q('[data-shb-fix-amt]').textContent = '\u2212' + F0(cur.fx); }
    }
    q('[data-shb-sticky-price]').textContent = act ? cur.dtotf : cur.totf;
    var so = q('[data-shb-sticky-old]'); if (act){ so.textContent = cur.totf; so.hidden = false; } else { so.hidden = true; }
    // lista zestawu: przeceniona cena Arches + wiersz sumy (rabat zestawu jest DODATKOWY do aktualnych cen)
    var lAct = act && cur.a.dpf, lAp = q('[data-shb-a-price]');
    if (lAp){
      lAp.textContent = cur.a.pf;
      // przekreslona: compare-at z Shopify (jesli jest), w przeciwnym razie cena sprzed rabatu zestawu
      // w akcji: przekreslona zwykla cena lukow (np. 179), obok cena w zestawie (np. 150); poza akcja przekreslenie z Shopify (compare-at)
      var lAo = q('[data-shb-a-old]'), lAold = cur.a.cf || ''; lAo.textContent = lAold; lAo.hidden = !lAold;
      var dRow = q('[data-shb-disc-row]'); if (dRow){ dRow.hidden = !lAct; q('[data-shb-disc-amt]').textContent = '\u2212' + (T.savef || ''); }
      var lSp = q('[data-shb-s-p]'), lSo2 = q('[data-shb-s-old]');
      if (lSo2){ lSo2.textContent = cur.s.cf || ''; lSo2.hidden = !cur.s.cf; lSp.classList.toggle('is-sale', !!cur.s.cf); }
      q('[data-shb-a-p]').classList.toggle('is-sale', !!cur.a.cf);
      var lAt = q('[data-shb-a-tag]'); lAt.hidden = true;
      var lSum = q('[data-shb-sum]'); lSum.classList.toggle('is-offer', !!act);
      q('[data-shb-sum-total]').textContent = act ? cur.dtotf : cur.totf;
      var lSoldTxt = act ? cur.totf : (((S.show_compare_at || S.show_save) && cur.cmpf) ? cur.cmpf : ''), lSo = q('[data-shb-sum-old]'); lSo.textContent = lSoldTxt; lSo.hidden = !lSoldTxt;
      var lSt = q('[data-shb-sum-tag]'); lSt.hidden = true;
      // korzysc akcji zamiast sumy przekreslen: "%amount% off the set: stara -> nowa"
      var lSs = q('[data-shb-sum-save]'); if (lSs){ lSs.textContent = ''; lSs.hidden = true; }
    }
    renderOfferTexts();
  }
  // ---- animation images ----
  function renderAnim(){
    var a = q('[data-shb-anim-arch]'), s = q('[data-shb-anim-sofa]'), b = q('[data-shb-anim-build]'), box = q('[data-shb-anim]');
    var set = cur.an || ANIM;
    lazySet(a, set); lazySet(s, set);
    var bsrc = cur.slug === 'vanilla' ? BUILT : '';
    if (bsrc){ lazySet(b, bsrc); b.alt = T.build_alt.replace('%colour%', 'Vanilla'); b.hidden = false; } else { b.hidden = true; }
    box.classList.toggle('no-build', !bsrc);
  }
  var cardIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting && e.target.dataset.src){ e.target.src = e.target.dataset.src; e.target.removeAttribute('data-src'); cardIO.unobserve(e.target); } }); }, { rootMargin: '300px 0px' }) : null;
  function lazySet(im, u){ if (!im || !u) return; var r = im.getBoundingClientRect(), shown = r.width > 0 && r.height > 0; if (!cardIO || (shown && r.top < innerHeight + 300 && r.bottom > -300)){ if (im.getAttribute('src') !== u) im.src = u; } else { im.dataset.src = u; cardIO.observe(im); } }
  function render(){
    q('[data-shb-colour-name]').textContent = cur.c;
    q('[data-shb-s-colour]').textContent = cur.c; q('[data-shb-a-colour]').textContent = cur.ac || cur.c;
    q('[data-shb-s-price]').textContent = cur.s.pf; q('[data-shb-a-price]').textContent = cur.a.pf;
    lazySet(q('[data-shb-s-img]'), cur.si); lazySet(q('[data-shb-a-img]'), cur.ai);
    lazySet(q('[data-shb-card-s-img]'), cur.si6 || cur.si); lazySet(q('[data-shb-card-a-img]'), cur.ai6 || cur.ai);
    setLink('[data-shb-s-link],[data-shb-s-link2]', cur.s.u, cur.s.id); setLink('[data-shb-a-link],[data-shb-a-link2]', cur.a.u, cur.a.id);
    [['s', 'sn', '[data-shb-s-link],[data-shb-s-name]'], ['a', 'anm', '[data-shb-a-link],[data-shb-a-name]'], ['x', 'xnm', '[data-shb-x-link],[data-shb-x-name]']].forEach(function(r){
      root.querySelectorAll(r[2]).forEach(function(el){ if (el.dataset.orig === undefined) el.dataset.orig = el.textContent; el.textContent = cur[r[1]] || el.dataset.orig; }); });
    if (cur.x){ var xc = q('[data-shb-x-colour]'); if (xc) xc.textContent = cur.x.col || cur.c; var xp = q('[data-shb-x-price]'); if (xp) xp.textContent = cur.x.pf; var xo = q('[data-shb-x-old]'); if (xo){ xo.textContent = cur.x.cf || ''; xo.hidden = !cur.x.cf; } var xpp = q('[data-shb-x-p]'); if (xpp) xpp.classList.toggle('is-sale', !!cur.x.cf); lazySet(q('[data-shb-x-img]'), cur.xi); lazySet(q('[data-shb-card-x-img]'), cur.xi6 || cur.xi); setLink('[data-shb-x-link],[data-shb-x-link2]', cur.x.u, cur.x.id); }
    lazySet(q('[data-shb-sticky-img]'), cur.si);
    q('[data-shb-sticky-title]').textContent = T.sticky_title + ' \u00b7 ' + cur.c;
    renderPrice();
    cta.disabled = !cur.ok; ctaS.disabled = !cur.ok;
    document.querySelectorAll('[data-shb-final-cta]').forEach(function(b){ b.disabled = !cur.ok; });
    msg.className = 'shb__msg'; msg.textContent = cur.ok ? '' : T.t_unavailable;
    swBox.querySelectorAll('button').forEach(function(b){ var on = b.dataset.colour === cur.c; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
    buildGal(); renderAnim();
  }
  function buildSwatches(){ swBox.innerHTML = ''; pairs.forEach(function(p){
    if (!inFab(p)) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'shb__swatch'; b.dataset.colour = p.c; b.setAttribute('aria-label', p.c); b.setAttribute('aria-pressed', 'false');
    b.style.setProperty('--swatch-img', 'url(' + swatchBase.replace('vanilla.png', (p.sw || p.slug) + '.png') + ')');
    if (!p.ok) b.disabled = true;
    b.addEventListener('click', function(){ cur = p; render(); });
    b.addEventListener('pointerdown', function(){ preload(p); }, { passive: true });
    b.addEventListener('touchstart', function(){ preload(p); }, { passive: true });
    swBox.appendChild(b);
  }); }
  buildSwatches();
  (function(){
    var box = q('[data-shb-fabs]'), row = q('[data-shb-fabrow]'), nm = q('[data-shb-fab-name]');
    if (!box || FABS.length < 2) return;
    box.hidden = false;
    function mark(){ row.querySelectorAll('button').forEach(function(b){ var on = b.dataset.fab === curFab; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); }); var f = FABS.filter(function(x){ return x.k === curFab; })[0]; if (nm) nm.textContent = f ? f.n : ''; var tb = root.querySelector('.shb__tabs'); if (tb) tb.hidden = curFab !== FABS[0].k; }
    FABS.forEach(function(f){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'shb__fab'; b.dataset.fab = f.k; b.textContent = f.n;
      function go(){ var c = cur && cur.c.toLowerCase(); curFab = f.k; cur = (c && byColour(c)) || firstOk(); if (!cur.ok) cur = firstOk(); buildSwatches(); mark(); render();
        try { var u = new URL(location.href); u.searchParams.set('stoff', curFab); history.replaceState(null, '', u); } catch (e) {} }
      b.addEventListener('click', function(){ if (curFab === f.k && !row.dataset.want) return; row.dataset.want = f.k; row.classList.add('is-loading'); loadFab(f.k).then(function(){ if (row.dataset.want !== f.k) return; row.dataset.want = ''; row.classList.remove('is-loading'); go(); }, function(){ if (row.dataset.want === f.k){ row.dataset.want = ''; row.classList.remove('is-loading'); } }); });
      b.addEventListener('pointerdown', function(){ loadFab(f.k).catch(function(){}); }, { passive: true });
      if (f.k === wantFab && wantFab !== curFab) setTimeout(function(){ b.click(); }, 0);
      row.appendChild(b);
    });
    mark();
  })();

  // ---- add to cart (both variants, hidden property __bundle: UpCart hides names with two leading underscores) ----
  function allBtns(){ return [cta, ctaS].concat(Array.prototype.slice.call(document.querySelectorAll('[data-shb-final-cta]'))); }
  function setBtns(dis){ allBtns().forEach(function(b){ if (b) b.disabled = dis; }); }
  function note(text, err){
    msg.className = 'shb__msg' + (err ? ' is-error' : ''); msg.textContent = text;
    document.querySelectorAll('[data-shb-final-msg]').forEach(function(m){ m.className = 'shb__msg' + (err ? ' is-error' : ''); m.textContent = text; });
  }
  function add(){
    if (!cur.ok) return;
    var props = { __bundle: C[68] };
    var payload = { items: [ { id: cur.s.id, quantity: 1, properties: props }, { id: cur.a.id, quantity: 1, properties: props } ] };
    if (cur.x) payload.items.push({ id: cur.x.id, quantity: 1, properties: props });
    setBtns(true); note(T.t_adding, false);
    fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){
        // UpCart: otworz drawer zamiast przechodzic na /cart (ten sam wzorzec co na stronach produktow motywu)
        if (S.open_drawer && typeof window.upcartOpenCart === 'function'){
          try {
            if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
            window.upcartOpenCart(); note('', false);
            setTimeout(function(){ setBtns(false); }, 1500);
            return;
          } catch (e) {}
        }
        window.location.href = cartUrl;
      })
      .catch(function(err){ setBtns(false); note((err && err.description) ? err.description : T.t_error, true); });
  }
  cta.addEventListener('click', add); ctaS.addEventListener('click', add);
  render();

  // ---- offer window + countdown (fixed UTC timestamps; Warsaw CEST = UTC+2 on these dates) ----
  var START = Date.parse(T.start); if (isNaN(START)) START = Date.parse('2026-10-15T22:00:00Z');
  var END = Date.parse(T.end); if (isNaN(END)) END = Date.parse('2026-10-19T21:59:59Z');
  END += 999; // the last second (23:59:59) still counts
  var preview = params.get('timer_preview') === '1';
  function startTxt(){ return wDate(START); }
  function endTxt(){ return wDate(END - 999); }
  var tEnd = q('[data-shb-timer-end]'); if (tEnd) tEnd.textContent = String(T.timer_end || '').replace('%end_short%', wShort(END - 999)).replace('%end%', endTxt());
  var skew = 0; // server time minus device time (corrects a wrong device clock)
  function nowMs(){ return Date.now() + skew; }
  var previewEnd = null;
  function targetEnd(){
    if (!preview) return END;
    var n = nowMs();
    if (n < END) return END;
    if (previewEnd === null) previewEnd = n + (END - START); // real offer is over: fake 4-day countdown for testing only
    return previewEnd;
  }
  var tBox = q('[data-shb-timer]'), tD = q('[data-shb-t="d"]'), tH = q('[data-shb-t="h"]'), tM = q('[data-shb-t="m"]'), tS = q('[data-shb-t="s"]');
  var bar = q('[data-shb-bar]'), barText = q('[data-shb-bar-text]'), barT = q('[data-shb-bar-t]');
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function warsawDay(ms){ try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ms)); } catch (e) { return ''; } }
  function stateNow(){
    if (!T.disc) return 'off';
    if (preview) return 'active';
    var n = nowMs();
    if (n < START) return 'before';
    if (n > END) return 'ended';
    return 'active';
  }
  var lastSec = -1;
  function tick(){
    var st = stateNow(), changed = false;
    if (st !== offerState){
      offerState = st; changed = true;
      bar.hidden = !(st === 'active' || st === 'before');
      q('[data-shb-bar-prev]').hidden = !(preview && st === 'active');
      barT.hidden = true;
      if (tBox){ tBox.hidden = st !== 'active'; var pb = q('[data-shb-timer-prev]'); if (pb) pb.hidden = !(preview && st === 'active'); }
      if (st === 'before'){
        var d = warsawDay(nowMs()), sd = warsawDay(START), tomorrow = warsawDay(nowMs() + 86400000);
        var hm = wTime(START), midnight = /^(00|24)[:.]00$/.test(hm);
        var tz = (d === sd) ? T.teaser_today : (tomorrow === sd ? (midnight ? T.teaser_midnight : T.teaser_tomorrow) : T.teaser_date);
        barText.textContent = amt(tz).replace('%time%', hm).replace('%date%', wDate(START));
      }
      lastSec = -1;
    }
    var left = 0, s = 0;
    if (st === 'active'){
      left = Math.max(0, targetEnd() - nowMs()); s = Math.floor(left / 1000);
      var u = s < 86400;
      if (u !== urgent){ urgent = u; changed = true; lastSec = -1; }
    } else if (urgent){ urgent = false; changed = true; }
    if (changed){ renderPrice(); }
    if (st !== 'active') return;
    if (s === lastSec) return;
    lastSec = s;
    var dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
    var compact = (dd > 0 ? dd + ' d ' : '') + pad(hh) + ':' + pad(mm) + ':' + pad(ss);
    barT.textContent = T.bar_timer.replace('%t%', compact);
    if (tBox){ tD.textContent = pad(dd); tH.textContent = pad(hh); tM.textContent = pad(mm); tS.textContent = pad(ss); tBox.classList.toggle('is-urgent', urgent); q('[data-shb-timer-title]').textContent = urgent ? T.timer_title_last : T.timer_title; if (ss === 0 || !tBox.getAttribute('aria-label')) tBox.setAttribute('aria-label', T.timer_title + ' ' + dd + ' ' + q('.shb__cell small').textContent + ' ' + hh + ':' + pad(mm)); }
    bar.classList.toggle('is-urgent', urgent);
    barText.textContent = urgent ? T.bar_text_last : amt(T.bar_text);
  }
  if (T.disc){
    tick();
    setInterval(tick, 500);
    try {
      fetch(cartUrl.replace(/\/$/, '') + '.js', { method: 'HEAD', cache: 'no-store' }).then(function(r){
        var h = r.headers.get('date'); if (h){ var sv = Date.parse(h); if (!isNaN(sv)) { skew = sv - Date.now(); tick(); } }
      }).catch(function(){});
    } catch (e) {}
  }

  // ---- sticky bar ----
  var sticky = q('[data-shb-sticky]');
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ sticky.classList.toggle('is-shown', !e.isIntersecting); document.documentElement.classList.toggle('shb-sticky-on', !e.isIntersecting); }); }, { threshold: 0.6 });
    io.observe(cta);
  } else { sticky.classList.add('is-shown'); document.documentElement.classList.add('shb-sticky-on'); }
  // ---- przycisk zestawu: wysokosc paska sticky (miejsce na dole strony) + uniesienie nad czatem / paskiem UpCart ----
  (function(){
    var de = document.documentElement, lastLift = -1, lastH = -1, tm = 0;
    function floaters(){
      var vh = window.innerHeight, lift = 0, list = document.querySelectorAll('body > *, body > * > *, body > * > * > *');
      for (var i = 0; i < list.length; i++){
        var el = list[i];
        if (root.contains(el) || el.contains(root) || el === sticky) continue;
        var s = getComputedStyle(el);
        if (s.position !== 'fixed' || s.display === 'none' || s.visibility === 'hidden' || +s.opacity === 0 || s.pointerEvents === 'none') continue;
        var r = el.getBoundingClientRect();
        if (r.height < 10 || r.width < 10 || r.height > vh * 0.45) continue;      // pelnoekranowe szuflady (UpCart) pomijamy
        if (r.top < vh * 0.5 || r.bottom < vh - 160 || r.bottom > vh + 2) continue; // tylko dolny pas ekranu
        lift = Math.max(lift, Math.round(vh - r.top + 8));
      }
      return lift;
    }
    function measure(){
      tm = 0;
      var lift = floaters(), h = sticky.offsetHeight;
      if (lift !== lastLift){ lastLift = lift; sticky.style.bottom = lift + 'px'; de.style.setProperty('--shb-lift', lift + 'px'); }
      if (h !== lastH){ lastH = h; de.style.setProperty('--shb-sticky-h', h + 'px'); }
    }
    function later(){ if (!tm) tm = setTimeout(measure, 150); }
    window.addEventListener('resize', later); window.addEventListener('orientationchange', later);
    if ('MutationObserver' in window) new MutationObserver(later).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    sticky.addEventListener('transitionend', later);
    measure(); setTimeout(measure, 1200);
  })();

  // ---- video: muted, plays on click ----
  var vcards = root.querySelectorAll('[data-shb-vcard]');
  var vReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vSave = navigator.connection && navigator.connection.saveData;
  function vLoopStart(card){
    var lv = card.querySelector('.shb__vloop'); if (!lv || card.classList.contains('is-playing')) return;
    if (!lv.getAttribute('src') && card.getAttribute('data-loop')){
      lv.addEventListener('playing', function(){ card.classList.add('is-loop'); }, { once: true });
      lv.src = card.getAttribute('data-loop');
    }
    var p = lv.play(); if (p && p.catch) p.catch(function(){});
  }
  function vLoopStop(card){ var lv = card.querySelector('.shb__vloop'); if (lv && lv.getAttribute('src')) lv.pause(); }
  function vReset(card){
    var fv = card.querySelector('.shb__vfull'); if (fv){ fv.pause(); fv.hidden = true; }
    card.classList.remove('is-playing');
  }
  if (!vReduce && !vSave && 'IntersectionObserver' in window){
    var vio = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) vLoopStart(e.target); else vLoopStop(e.target); }); }, { threshold: 0.4 });
    Array.prototype.forEach.call(vcards, function(c){ vio.observe(c); });
  }
  Array.prototype.forEach.call(vcards, function(card){
    var fv = card.querySelector('.shb__vfull'), vbtn = card.querySelector('[data-shb-vplay]');
    if (!fv || !vbtn) return;
    fv.addEventListener('ended', function(){ vReset(card); });
    vbtn.addEventListener('click', function(){
      Array.prototype.forEach.call(vcards, function(c){ if (c !== card) vReset(c); });
      vLoopStop(card);
      if (!fv.getAttribute('src')){ fv.preload = 'auto'; fv.src = card.getAttribute('data-full'); }
      fv.hidden = false; fv.muted = true; fv.controls = true; card.classList.add('is-playing');
      var p = fv.play();
      if (!fv.dataset.shbMute){ fv.dataset.shbMute = '1'; fv.addEventListener('volumechange', function(){ if (!fv.muted) fv.muted = true; }); }
      if (p && p.catch) p.catch(function(){ fv.muted = true; var p2 = fv.play(); if (p2 && p2.catch) p2.catch(function(){ vReset(card); }); });
    });
  });
  (function(){
    var vt = q('[data-shb-vtrack]'), vp = q('[data-shb-vprev]'), vn = q('[data-shb-vnext]'), vd = q('[data-shb-vdots]');
    if (!vt || !vcards.length) return;
    function step(){ var c = vcards[0]; return c.getBoundingClientRect().width + 10; }
    function go(i){ i = Math.max(0, Math.min(vcards.length - 1, i)); vt.scrollTo({ left: i * step(), behavior: reduce ? 'auto' : 'smooth' }); }
    function cur(){ return Math.round(vt.scrollLeft / step()); }
    if (vp) vp.addEventListener('click', function(){ go(cur() - 1); });
    if (vn) vn.addEventListener('click', function(){ go(cur() + 1); });
    var dots = [];
    if (vd){
      Array.prototype.forEach.call(vcards, function(c, i){ var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', (i + 1) + ' / ' + vcards.length); d.addEventListener('click', function(){ go(i); }); vd.appendChild(d); dots.push(d); });
    }
    function mark(){ var k = cur(); dots.forEach(function(d, i){ d.classList.toggle('is-on', i === k); }); }
    var tick = false; vt.addEventListener('scroll', function(){ if (tick) return; tick = true; requestAnimationFrame(function(){ tick = false; mark(); }); }, { passive: true });
    mark();
  })();

  // ---- bottom animation: once, when it scrolls into view ----
  var anim = q('[data-shb-anim]');
  if (anim && 'IntersectionObserver' in window && !reduce){
    anim.classList.add('is-armed');
    var aio = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ anim.classList.add('is-play'); aio.disconnect(); } }); }, { threshold: 0.4 });
    aio.observe(anim);
  }

  // ---- delivery estimate (same logic as the other product pages) ----
  (function(){
    var target = document.getElementById('shb-arrival-' + C[5]);
    if (!target || !window.Intl || !Intl.DateTimeFormat) return;
    var minimum = parseInt(target.getAttribute('data-min-days'), 10);
    var maximum = parseInt(target.getAttribute('data-max-days'), 10);
    if (!minimum || !maximum) return;
    function addBusinessDays(start, count) {
      var result = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 12);
      var added = 0;
      while (added < count) { result.setDate(result.getDate() + 1); var day = result.getDay(); if (day !== 0 && day !== 6) added += 1; }
      return result;
    }
    var language = C[69];
    var locales = { en: 'en-GB', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', nl: 'nl-NL', pl: 'pl-PL' };
    var locale = locales[language] || 'en-GB';
    var formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });
    var first = addBusinessDays(new Date(), minimum);
    var last = addBusinessDays(new Date(), maximum);
    var firstParts = formatter.formatToParts(first);
    var lastParts = formatter.formatToParts(last);
    var firstDay = firstParts.find(function(part) { return part.type === 'day'; }).value;
    var lastDay = lastParts.find(function(part) { return part.type === 'day'; }).value;
    var monthName = lastParts.find(function(part) { return part.type === 'month'; }).value;
    var sameMonth = first.getMonth() === last.getMonth() && first.getFullYear() === last.getFullYear();
    var text;
    if (sameMonth) {
      if (language === 'de') text = firstDay + '. bis ' + lastDay + '. ' + monthName;
      else if (language === 'fr') text = 'du ' + firstDay + ' au ' + lastDay + ' ' + monthName;
      else if (language === 'es') text = 'del ' + firstDay + ' al ' + lastDay + ' de ' + monthName;
      else if (language === 'nl') text = firstDay + ' t/m ' + lastDay + ' ' + monthName;
      else if (language === 'pl') text = 'od ' + firstDay + ' do ' + lastDay + ' ' + monthName;
      else text = firstDay + ' to ' + lastDay + ' ' + monthName;
    } else {
      var ff = formatter.format(first), lf = formatter.format(last);
      if (language === 'de') text = ff + ' bis ' + lf;
      else if (language === 'fr') text = 'du ' + ff + ' au ' + lf;
      else if (language === 'es') text = 'del ' + ff + ' al ' + lf;
      else if (language === 'nl') text = ff + ' t/m ' + lf;
      else if (language === 'pl') text = 'od ' + ff + ' do ' + lf;
      else text = ff + ' to ' + lf;
    }
    target.textContent = text;
  })();

  // ---- hand-over for the FAQ section (separate file, after the reviews) ----
  window.SHB = { add: add, savef: T.savef, label: ctaLabel, main: function(){ return T.cta; }, badge: ctaBadge, trust: T.trust, promo: promo, archNew: archNew, archOld: archOld, ok: function(){ return cur.ok; }, price: function(){ return (promo() && cur.dtotf) ? cur.dtotf : cur.totf; }, start: startTxt, end: endTxt };
  document.dispatchEvent(new CustomEvent('shb:update', { detail: { savef: T.savef, state: offerState, promo: promo(), label: ctaLabel(), main: T.cta, badge: '', trust: T.trust, price: window.SHB.price(), archNew: archNew(), archOld: archOld(), start: startTxt(), end: endTxt() } }));
})();
